import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpHandler, HttpRequest } from "@angular/common/http";
import { CacheService } from "../services/cache.service";
import { environment } from "src/environments/environment";
import { JWTService } from "../services/jwt.service";
import { EMPTY } from "rxjs";

const { HOST_ZONE } = environment;

@Injectable({
  providedIn: "root",
})
export class AuthInterceptor implements HttpInterceptor {
  private _request: HttpRequest<any>;
  constructor(private _cacheService: CacheService, private _jwtService: JWTService) {}

  private _isGraphCall() {
    return this._request.url.includes(`graph.${HOST_ZONE}`);
  }

  private _graphContainsPatientRequest() {
    if (!this._isGraphCall()) return false;
    const isPatientRequest = this._request.body.query.trim().replace(/\s+/g, "").includes("patient{");
    return isPatientRequest;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    this._request = req;
    const preventCall = (this._jwtService.isPublicAccess() || this._jwtService.hasExpired) && this._graphContainsPatientRequest();

    if (preventCall) {
      // If the request is a sensitive graph call and the user is public or has expired JWT, we should not make the API call.
      window.location.href = `${window.location.origin}/`;
      return EMPTY;
    }

    const jwt = this._cacheService.get("jwt");
    // If we have a JWT pass on the request with the Authorization header.
    if (jwt) {
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${jwt}`,
        },
      });

      return next.handle(authReq);
      // If we dont have a JWT and the request is for the app init domains call then pass it on to the next handler.
    } else if (req.url.includes("/api/domains/info")) {
      return next.handle(req);
    }

    return next.handle(req);
  }
}
